<template lang="pug">
  .layout
    y-dialog(v-model="showModal" persistent max-width="320")
      v-card
        v-card-title.h6.text-wrapper.pt-6 {{ $t('title') }}
        v-card-text.p2.primary500--text.px-6.text-wrapper {{ errorMessage }}
        v-card-actions.pb-4.px-4
          v-spacer
          v-btn.button-AA-tiny.info500.basic100--text(small depressed :loading="loading" @click="closeDialog") {{ $t('confirm') }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CancelLocalDeliveryError',
  props: {
    open: {
      type: Boolean
    },
    error: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  mounted() {
    this.fetchOngoing()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(val) {
        this.$emit('update:open', val)
      }
    },
    errorMessage() {
      switch (this.error.code) {
        case '444003':
          return this.$t('errorMessage.444003')

        case '444004':
          return this.$t('errorMessage.444004')

        default:
          return this.$t('errorMessage.default')
      }
    }
  },
  methods: {
    fetchOngoing() {
      const params = { company: this.company.id }
      this.$axios
        .get('/shipping/yezzashipping/ongoing', { params })
        .then(resp => {
          this.$store.commit('riders/updateOngoingData', resp.data)
        })
        .catch(() => {})
    },
    closeDialog() {
      this.$emit('close')
      this.showModal = false
    }
  }
}
</script>

<style scoped>
</style>


<i18n>
{
  "en": {
    "title": "Sorry, we couldn't cancel your order",
    "errorMessage": {
      "default": "Unable to complete your request. Please try again later",
      "444003": "A rider has already accepted this job",
      "444004": "This order already failed. Please try again"
    },
    "confirm": " Got it"
  },
  "id": {
    "title": "Maaf order kamu tidak dapat dibatalkan",
    "errorMessage": {
      "default": "Tidak dapat menyelesaikan permintaan kamu. Silakan coba lagi nanti",
      "444003": "Seorang pengendara telah menerima pekerjaan ini",
      "444004": "Order ini sudah gagal. Silakan coba lagi"
    },
    "confirm": " mengerti"
  }
}
</i18n>